import { TInitialValues, TInput_list } from "./FormAddingCallingList.props";

export const INPUTS_LIST: TInput_list = [
	{ label: "input_listName", title: "name", type: "text" },
	{
		label: "title_channels",
		title: "channels",
		type: "select",
		variants: [
			{ title: "title_voice", value: "voice" },
			{ title: "title_telegram", value: "telegram" },
		],
	},
	{ label: { voice: "input_phoneNumber", telegram: "input_botName" }, title: "source", type: "text" },
	{ label: "selectItem_timeintervals", title: "timeintervals", type: "select", variants: [{ title: "title_telegram", value: "telegram" }] },
];

export const initialValues: TInitialValues = {
	name: "",
	source: "",
	timeintervals: ["default"],
	channel:
		INPUTS_LIST.find(
			(el): el is { label: string; title: string; type: "select"; variants: { title: string; value: "voice" | "telegram" }[] } =>
				el.type === "select" && el.title === "channels"
		)?.variants?.[0]?.value ?? "voice",
	robotId: "",
	endpointId: "",
};
